import { merge } from 'merge-anything';
import { z } from 'zod';
import { config } from '@orionprotocol/sdk';
import BigNumber from 'bignumber.js';

import uiConfigEnv from './config/envs.json';
import { envSchema } from './config/schemas/envSchema';

const combinedEnvs = merge(config.envs, uiConfigEnv);
const environment = z.string().parse(import.meta.env.VITE_ENV);

const envs = envSchema.parse(combinedEnvs);

if (!Object.keys(envs).includes(environment)) {
  throw new Error(`
    Environment must be one of these: ${Object.keys(envs).join(', ')}.
    Received: ${environment}
  `);
}

BigNumber.config({ EXPONENTIAL_AT: 1e9 });

export { envs, environment };
